var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMessageIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_734_2536)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 10C20 4.47715 15.5228 0 10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20C15.5228 20 20 15.5228 20 10Z",
    fill: "#2E77D0",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 7L8.45651 8.95849C9.7308 9.6805 10.2692 9.6805 11.5435 8.95849L15 7",
    stroke: "#2E77D0",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.00789 10.7378C5.04057 12.2706 5.05692 13.0369 5.62248 13.6047C6.18804 14.1724 6.97516 14.1921 8.54941 14.2317C9.51965 14.2561 10.4803 14.2561 11.4506 14.2317C13.0248 14.1921 13.8119 14.1724 14.3775 13.6047C14.9431 13.0369 14.9594 12.2706 14.9921 10.7378C15.0026 10.245 15.0026 9.75505 14.9921 9.2622C14.9594 7.72943 14.9431 6.96305 14.3775 6.39533C13.8119 5.82762 13.0248 5.80784 11.4506 5.76829C10.4803 5.74391 9.51965 5.74391 8.54941 5.76828C6.97516 5.80783 6.18804 5.82761 5.62247 6.39533C5.05691 6.96304 5.04057 7.72943 5.00788 9.2622C4.99737 9.75505 4.99738 10.245 5.00789 10.7378Z",
    stroke: "#2E77D0",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_734_2536"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessageIcon);
export default __webpack_public_path__ + "static/media/messageIcon.8c91ad6dff8b25ce7bd5a24d69c4d5f9.svg";
export { ForwardRef as ReactComponent };